module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.adding) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mapCoords
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Nominal",
      "class-name": "hidden-md-and-down"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Lat.",
      "prop": "nominalLat",
      "class-name": "hidden-md-and-down"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Lng.",
      "prop": "nominalLng",
      "class-name": "hidden-md-and-down"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Candidate",
      "class-name": "hidden-md-and-down"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Lat.",
      "prop": "candLat",
      "class-name": "hidden-md-and-down"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Lng.",
      "prop": "candLng",
      "class-name": "hidden-md-and-down"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Distance",
      "class-name": "hidden-md-and-down"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "m.",
      "prop": "distance",
      "class-name": "hidden-md-and-down"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('google-map', {
    attrs: {
      "lat": _vm.rowData.site.latitude,
      "lng": _vm.rowData.site.longitude,
      "zoom": 17,
      "markers": _vm.rta.markers,
      "add-markers": _vm.editable && !_vm.disabled,
      "delete-markers": _vm.editable && !_vm.disabled,
      "drag-markers": _vm.editable && !_vm.disabled,
      "show-nominal": "",
      "map-style": _vm.style,
      "options": ['option', 'access', 'power', 'building'],
      "optionIcons": ['fa fa-bullseye', 'fa fa-road', 'fa fa-plug', 'fa fa-home'],
      "optionMapPins": _vm.mapPins
    },
    on: {
      "changed": _vm.updateMarker
    }
  }), _vm._v(" "), _c('edit-pane', {
    ref: "opt",
    attrs: {
      "prefix": _vm.rta.clientStatus ? _vm.rta.clientStatus : 'Option: ',
      "title": '#' + _vm.rta.optionNo + ' Site Name: ' + _vm.site.siteName,
      "editable": _vm.editable
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit
    }
  }), _vm._v(" "), (_vm.isTowerCo() && _vm.isApproved()) ? _c('section', [_c('center', {
    staticStyle: {
      "padding-bottom": "1em"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.approve
    }
  }, [_vm._v("Approve RTA")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": "",
      "model": _vm.rta,
      "label-position": "top"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Details"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.rta,
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    }
  }, [(_vm.isTowerCo()) ? _c('select-site-status', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.siteStatus),
      callback: function($$v) {
        _vm.$set(_vm.rta, "siteStatus", $$v)
      },
      expression: "rta.siteStatus"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && !_vm.rta.client_id) ? _c('select-sharer', {
    model: {
      value: (_vm.rta.client_id),
      callback: function($$v) {
        _vm.$set(_vm.rta, "client_id", $$v)
      },
      expression: "rta.client_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Client Ref.",
      "placeholder": (_vm.rta.client && _vm.rta.client.shortName ? _vm.rta.client.shortName : 'Our') + ' Ref:',
      "disabled": _vm.disabled || _vm.isTowerCo()
    },
    model: {
      value: (_vm.rta.clientRef),
      callback: function($$v) {
        _vm.$set(_vm.rta, "clientRef", $$v)
      },
      expression: "rta.clientRef"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8,
      "align": "center"
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Option Title",
      "placeholder": "Option Title",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.title),
      callback: function($$v) {
        _vm.$set(_vm.rta, "title", $$v)
      },
      expression: "rta.title"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Ref.",
      "placeholder": _vm.xolasClient().shortName + ' Ref:',
      "disabled": _vm.disabled || _vm.isTelco()
    },
    model: {
      value: (_vm.rta.ref),
      callback: function($$v) {
        _vm.$set(_vm.rta, "ref", $$v)
      },
      expression: "rta.ref"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 8,
      "lg": 6
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.addSuffix(_vm.rta.optionNo))
    }
  }), _vm._v(" Option\n              ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 8,
      "lg": 12,
      "align": "center"
    }
  }, [_vm._v("\n                 \n              ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Survey Date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.surveyDate),
      callback: function($$v) {
        _vm.$set(_vm.rta, "surveyDate", $$v)
      },
      expression: "rta.surveyDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Land Details")])]), _vm._v(" "), _c('select-land-type', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.landType),
      callback: function($$v) {
        _vm.$set(_vm.rta, "landType", $$v)
      },
      expression: "rta.landType"
    }
  }), _vm._v(" "), _c('select-classification-type', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.classificationType),
      callback: function($$v) {
        _vm.$set(_vm.rta, "classificationType", $$v)
      },
      expression: "rta.classificationType"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('time-input', {
    attrs: {
      "label": "From Time",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.fromTime),
      callback: function($$v) {
        _vm.$set(_vm.rta, "fromTime", $$v)
      },
      expression: "rta.fromTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Access Hours",
      "prefix": "fa fa-hourglass-half",
      "is-prefix-icon": "",
      "min": 0,
      "max": 24,
      "suffix": "hr.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.hoursAccessSite),
      callback: function($$v) {
        _vm.$set(_vm.rta, "hoursAccessSite", $$v)
      },
      expression: "rta.hoursAccessSite"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('check-box', {
    attrs: {
      "label": "Week Days Only",
      "icon": "fa fa-calendar-week",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.weekDaysOnly),
      callback: function($$v) {
        _vm.$set(_vm.rta, "weekDaysOnly", $$v)
      },
      expression: "rta.weekDaysOnly"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('check-box', {
    attrs: {
      "label": "Commerical Power",
      "icon": "fa fa-plug",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.commercialPowerAvailable),
      callback: function($$v) {
        _vm.$set(_vm.rta, "commercialPowerAvailable", $$v)
      },
      expression: "rta.commercialPowerAvailable"
    }
  }, [(_vm.rta.distanceNearestPower) ? _c('span', [_vm._v(" nearest: "), _c('b', [_vm._v(_vm._s(_vm.rta.distanceNearestPower))]), _vm._v("m.")]) : _vm._e()])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('check-box', {
    attrs: {
      "label": "Guidelines",
      "icon": "fa fa-list",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.guidelines),
      callback: function($$v) {
        _vm.$set(_vm.rta, "guidelines", $$v)
      },
      expression: "rta.guidelines"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }), _vm._v(" Structure Details")])]), _vm._v(" "), _c('select-coverage', {
    attrs: {
      "label": "Station Type",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.stationType),
      callback: function($$v) {
        _vm.$set(_vm.rta, "stationType", $$v)
      },
      expression: "rta.stationType"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [(_vm.disabled || _vm.isTelco()) ? _c('el-form-item', {
    attrs: {
      "label": "Structure Supplier"
    }
  }, [(_vm.rta.supplier.name) ? _c('i', {
    staticClass: "fa fa-broadcast-tower"
  }) : _vm._e(), _vm._v("\n                     " + _vm._s(_vm.rta.supplier.name) + "\n                  ")]) : _c('select-tower-supplier', {
    attrs: {
      "label": "Structure Supplier",
      "disabled": _vm.disabled || _vm.isTelco()
    },
    model: {
      value: (_vm.rta.supplier),
      callback: function($$v) {
        _vm.$set(_vm.rta, "supplier", $$v)
      },
      expression: "rta.supplier"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [(_vm.disabled || _vm.isTelco()) ? _c('el-form-item', {
    attrs: {
      "label": "Structure Type"
    }
  }, [(_vm.rta.structure) ? _c('i', {
    staticClass: "fa fa-broadcast-tower"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.rta.structure.name) + " \n                    "), (_vm.rta.structure && _vm.rta.structure.height) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.rta.structure.height) + "m.\n                    ")]) : _vm._e()]) : _c('select-structure', {
    attrs: {
      "label": "Structure Type",
      "disabled": _vm.disabled || _vm.isTelco()
    },
    model: {
      value: (_vm.rta.structure_id),
      callback: function($$v) {
        _vm.$set(_vm.rta, "structure_id", $$v)
      },
      expression: "rta.structure_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Structure Height",
      "min": 1,
      "max": 121,
      "suffix": "m.",
      "disabled": _vm.disabled || _vm.isTelco()
    },
    model: {
      value: (_vm.rta.structureHeight),
      callback: function($$v) {
        _vm.$set(_vm.rta, "structureHeight", $$v)
      },
      expression: "rta.structureHeight"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Antenna Height",
      "min": 0,
      "max": 121,
      "prefix": "fa fa-arrows-alt-v",
      "is-prefix-icon": "",
      "suffix": "m.",
      "disabled": _vm.disabled || _vm.isTelco()
    },
    model: {
      value: (_vm.rta.antennaHeight),
      callback: function($$v) {
        _vm.$set(_vm.rta, "antennaHeight", $$v)
      },
      expression: "rta.antennaHeight"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Report"
    }
  }, [_c('html-input', {
    attrs: {
      "label": "Report for Client",
      "disabled": _vm.disabled || _vm.isTelco()
    },
    model: {
      value: (_vm.rta.report),
      callback: function($$v) {
        _vm.$set(_vm.rta, "report", $$v)
      },
      expression: "rta.report"
    }
  })], 1), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-tab-pane', {
    attrs: {
      "label": "Land Owner"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" Owner")])]), _vm._v(" "), _c('select-locality', {
    attrs: {
      "label": "Locality",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.loc),
      callback: function($$v) {
        _vm.loc = $$v
      },
      expression: "loc"
    }
  }), _vm._v(" "), _c('select-landlord', {
    attrs: {
      "full-object": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updateOwner
    },
    model: {
      value: (_vm.rta.owner_id),
      callback: function($$v) {
        _vm.$set(_vm.rta, "owner_id", $$v)
      },
      expression: "rta.owner_id"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Owner",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.owner),
      callback: function($$v) {
        _vm.$set(_vm.rta, "owner", $$v)
      },
      expression: "rta.owner"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Address",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.address),
      callback: function($$v) {
        _vm.$set(_vm.rta, "address", $$v)
      },
      expression: "rta.address"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Post Code",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.rta.postCode),
      callback: function($$v) {
        _vm.$set(_vm.rta, "postCode", $$v)
      },
      expression: "rta.postCode"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Phone",
      "disabled": _vm.disabled || _vm.isTelco()
    },
    model: {
      value: (_vm.rta.phone),
      callback: function($$v) {
        _vm.$set(_vm.rta, "phone", $$v)
      },
      expression: "rta.phone"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('text-input', {
    attrs: {
      "label": "E-Mail",
      "disabled": _vm.disabled || _vm.isTelco()
    },
    model: {
      value: (_vm.rta.email),
      callback: function($$v) {
        _vm.$set(_vm.rta, "email", $$v)
      },
      expression: "rta.email"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Locality")])]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, [(_vm.rta.actualLat || _vm.rta.actualLng) ? _c('tr', [_c('td', [_vm._v("Geo:")]), _c('td', [_c('span', [_vm._v("lat: "), _c('strong', [_vm._v(_vm._s(_vm.rta.actualLat))]), _vm._v(" / lng: "), _c('strong', [_vm._v(_vm._s(_vm.rta.actualLng))])])])]) : _vm._e(), _vm._v(" "), (_vm.rta.zone) ? _c('tr', [_c('td'), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.rta.zone))])])]) : _vm._e(), _vm._v(" "), (_vm.rta.subdistrict || _vm.rta.district) ? _c('tr', [_c('td'), _c('td', [_c('i', [_vm._v(_vm._s(_vm.rta.subdistrict))]), _vm._v(" "), (_vm.rta.district) ? _c('i', [(_vm.rta.subdistrict) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.rta.district))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.rta.state) ? _c('tr', [_c('td'), _c('td', [_vm._v(_vm._s(_vm.rta.state))])]) : _vm._e(), _vm._v(" "), (_vm.rta.region) ? _c('tr', [_c('td'), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.rta.region))])])]) : _vm._e(), _vm._v(" "), (_vm.rta.country) ? _c('tr', [_c('td'), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.rta.country))])])]) : _vm._e()])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Client Response"
    }
  }, [_c('select-action-status', {
    attrs: {
      "label": "Client Status",
      "placeholder": "Client Status",
      "disabled": _vm.disabled || _vm.isTowerCo()
    },
    on: {
      "change": _vm.updateClientStatus
    },
    model: {
      value: (_vm.rta.clientStatus),
      callback: function($$v) {
        _vm.$set(_vm.rta, "clientStatus", $$v)
      },
      expression: "rta.clientStatus"
    }
  }), _vm._v(" "), _c('html-input', {
    attrs: {
      "label": "Client Remarks",
      "disabled": _vm.disabled || _vm.isTowerCo()
    },
    model: {
      value: (_vm.rta.clientRemarks),
      callback: function($$v) {
        _vm.$set(_vm.rta, "clientRemarks", $$v)
      },
      expression: "rta.clientRemarks"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.adding) ? _c('div', [_c('br'), _vm._v(" "), _c('files-panel', {
    attrs: {
      "title": "Options Attachments",
      "type": "site",
      "id": _vm.site.id,
      "process": "candidate",
      "process-id": _vm.rta.id,
      "max-files": 15,
      "disabled": _vm.disabled || _vm.isTelco()
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b8ef217"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/acquire/AcquireDetails.vue
// module id = 1620
// module chunks = 0